import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd';
import styles from './index.less'
import { print } from "@/utils/printUtils";
import moment from 'moment'
import { DPP_TREATMENT_PATH_PHYSIOLOGICAL } from '@/utils/consts'

const { TextArea } = Input;

const PrintModal = ({
  taskDetail = {},
  infos = {},
  visible,
  ...other
}) => {
  const [info, setInfo] = useState({})

  useEffect(() => {
    if (infos) {
      setInfo({ ...infos })
    }
  }, [infos])


  const handlePrint = () => {
    const printContent = document.getElementById("printDetails").parentNode;
    setTimeout(() => {
      print(printContent);
    }, 1500);
  }

  const modalProps = {
    visible: visible,
    // onCancel,
    width: 800,
    okText: '打印',
    ...other
  };

  const handleChange = (key, value) => {
    let newInfo = { ...info }
    newInfo[key] = value
    setInfo({ ...newInfo })
  }

  return (
    // <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>

    // </Modal>
    <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>
      <div id='printDetails'>
        <div className={styles.BSPPrint} id='printDetails'>
          <h2 className={'print-title'} style={{ textAlign: 'center' }}>BPS评估报告</h2>
          <div className={'print-sub-title'} style={{ display: 'flex', justifyContent: 'space-between', lineHeight: '28px', fontSize: '14px', color: '#40a9ff' }}>
            <div>BPS综合评估报告以及DPP循程服务个性化方案专业建议</div>
            <div>姓名：{taskDetail.customerName || taskDetail.name}</div>
          </div>
          {<div className={styles.bspCommontContain}>
            <h3 className='title'><div>心理问题（心理困扰）</div></h3>
            <Descriptions bordered column={1}>
              {
                // info.problemType &&
                // <Descriptions.Item span={1} label="问题标签">
                //   <div style={{ padding: '8px 16px' }}>
                //     <TextArea value={info.problemType} autoSize={{ minRows: 1 }} onChange={e => handleChange('problemType', e.target.value)} />
                //   </div>
                // </Descriptions.Item>
              }
              {
                info.questionTypeTwo &&
                <Descriptions.Item span={1} label="问题类型">
                  <div style={{ padding: '8px 16px' }}>
                    <TextArea value={info.questionTypeTwo} autoSize={{ minRows: 1 }} onChange={e => handleChange('questionTypeTwo', e.target.value)} />
                  </div>
                </Descriptions.Item>
              }
            </Descriptions>
          </div>}
          {
            // info.scl90TestResultSummary || info.sdsTestResultSummary || info.sasTestResultSummary || info.brainHealthAssessmentSummarize &&
            <div className={styles.bspCommontContain}>
              <h3 className='title'><div>专科检测</div></h3>
              <Descriptions bordered column={1}>
                {
                  info.scaleTestResultSummary &&
                  <Descriptions.Item span={1} label="量表结果">
                    <div style={{ padding: '8px 16px' }}>
                      <TextArea value={info.scaleTestResultSummary} autoSize={{ minRows: 1 }} onChange={e => handleChange('scaleTestResultSummary', e.target.value)} />
                    </div>
                  </Descriptions.Item>
                }
                {/* 
                {info.scl90TestResultSummary || info.sdsTestResultSummary || info.sasTestResultSummary &&
                  (<Descriptions.Item span={1} label="心理量表">
                    <div className={styles.bspCommontContainChild2} >
                      <Descriptions bordered column={1}>
                        {info.scl90TestResultSummary && <Descriptions.Item>
                          <div className={styles.bspCommontContainChild3}>
                            <Descriptions bordered column={10}>
                              <Descriptions.Item label="表1" span={4}><div style={{ padding: '8px' }}>心理健康自评量表(SCL-90)</div></Descriptions.Item>
                              <Descriptions.Item label="测验结果简述" span={6}>
                                <div style={{ padding: '8px 16px' }}>
                                  <TextArea value={info.scl90TestResultSummary} autoSize={{ minRows: 1 }} onChange={e => handleChange('scl90TestResultSummary', e.target.value)} />
                                </div>
                              </Descriptions.Item>
                            </Descriptions>
                          </div>
                        </Descriptions.Item>}
                        {info.sdsTestResultSummary && <Descriptions.Item>
                          <div className={styles.bspCommontContainChild3}>
                            <Descriptions bordered column={10}>
                              <Descriptions.Item className='descriptions3' label="表2" span={4}><div style={{ padding: '8px' }}>抑郁自评量表</div></Descriptions.Item>
                              <Descriptions.Item label="测验结果简述" span={6}><div style={{ padding: '8px 16px' }}>
                                <TextArea value={info.sdsTestResultSummary} autoSize={{ minRows: 1 }} onChange={e => handleChange('sdsTestResultSummary', e.target.value)} />
                              </div></Descriptions.Item>
                            </Descriptions>
                          </div>
                        </Descriptions.Item>}
                        {info.sasTestResultSummary && <Descriptions.Item>
                          <div className={styles.bspCommontContainChild3}>
                            <Descriptions bordered column={10}>
                              <Descriptions.Item label="表3" span={4}><div style={{ padding: '8px' }}>焦虑自评量表</div></Descriptions.Item>
                              <Descriptions.Item label="测验结果简述" span={6}><div style={{ padding: '8px 16px' }}>
                                <TextArea value={info.sasTestResultSummary} autoSize={{ minRows: 1 }} onChange={e => handleChange('sasTestResultSummary', e.target.value)} />
                              </div></Descriptions.Item>
                            </Descriptions>
                          </div>
                        </Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </Descriptions.Item>)
                }
                */}
                {info.brainHealthAssessmentSummarize &&
                  <Descriptions.Item label="脑健康分析">
                    <div className={styles.bspCommontContainChild}>
                      <Descriptions bordered column={1}>
                        <Descriptions.Item label='报告综述'>
                          <div style={{ padding: '8px 16px', minHeight: 40 }}>
                            <TextArea value={info.brainHealthAssessmentSummarize} autoSize={{ minRows: 1 }} onChange={e => handleChange('brainHealthAssessmentSummarize', e.target.value)} />
                          </div>
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
              </Descriptions>
            </div>
          }
          {/*  */}

          {(info.clinicalSymptom || info.originalFamily || info.personality || info.personalLife || info.socialFunction || info.socialConceptualization) &&
            <div className={styles.bspCommontContain}>
              <h3 className='title'><div>BPS评估</div></h3>
              <Descriptions bordered column={1}>

                <Descriptions.Item span={1} label="原因+细化问题表现">
                  <div className={styles.bspCommontContainChild4} >
                    <Descriptions bordered column={1}>
                      {/* {(info.clinicalSymptom || info.originalFamily || info.personality || info.personalLife || info.socialFunction) && */}
                      <Descriptions.Item span={3}>
                        <div>
                          <Descriptions bordered column={5}>
                            <Descriptions.Item className='descriptions20' span={1}>
                              <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>生物</div>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={2}>
                              <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>心理</div>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={2}>
                              <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>社会</div>
                            </Descriptions.Item>
                          </Descriptions>
                        </div>
                      </Descriptions.Item>
                      {/* <Descriptions.Item span={3}>
                        <div>
                          <Descriptions bordered column={3}>
                            <Descriptions.Item className='descriptions20' span={1}>
                              <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>症状表现</div>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={1}>
                              <Descriptions bordered column={2}>
                                <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>原生家庭</div></Descriptions.Item>
                                <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>人格</div></Descriptions.Item>
                              </Descriptions>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={1}>
                              <Descriptions bordered column={2}>
                                <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>个人生活</div></Descriptions.Item>
                                <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>社会功能</div></Descriptions.Item>
                              </Descriptions>
                            </Descriptions.Item>
                          </Descriptions>
                        </div>
                      </Descriptions.Item> */}
                      <Descriptions.Item span={3}>
                        <div>
                          <Descriptions bordered column={3}>
                            <Descriptions.Item className='descriptions20' span={1}>
                              <Descriptions bordered column={2}>
                                <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px 4px' }}>情绪、睡眠、注意力等</div></Descriptions.Item>
                                <Descriptions.Item className='descriptions4' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.clinicalSymptom}</div></Descriptions.Item>
                              </Descriptions>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={1}>
                              <Descriptions bordered column={2}>
                                <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px 4px' }}>原生家庭和人格特质（成长环境经历、原生家庭教养方式）</div></Descriptions.Item>
                                <Descriptions.Item className='descriptions4' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.originalFamily}</div></Descriptions.Item>
                                {/* <Descriptions.Item className='descriptions2' span={1}>
                                  <Descriptions bordered column={2}>
                                    <Descriptions.Item className='descriptions5' span={1}><div style={{ padding: '8px 4px' }}>家庭环境、教育方式等</div></Descriptions.Item>
                                    <Descriptions.Item className='descriptions6' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.originalFamily}</div></Descriptions.Item>
                                  </Descriptions>
                                </Descriptions.Item> */}
                                {/* <Descriptions.Item className='descriptions2' span={1}>
                                  <Descriptions bordered column={2}>
                                    <Descriptions.Item className='descriptions5' span={1}><div style={{ padding: '8px 4px' }}>性格、成长经历等</div></Descriptions.Item>
                                    <Descriptions.Item className='descriptions6' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.personality}</div></Descriptions.Item>
                                  </Descriptions>
                                </Descriptions.Item> */}
                              </Descriptions>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={1}>
                              <Descriptions bordered column={2}>
                                <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px 4px' }}>现实困扰和冲突（亲子&家庭&婚恋&职场学校中的能力&适应&人际等困扰）</div></Descriptions.Item>
                                <Descriptions.Item className='descriptions4' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.personalLife}</div></Descriptions.Item>
                                {/* <Descriptions.Item className='descriptions2' span={1}>
                                  <Descriptions bordered column={2}>
                                    <Descriptions.Item className='descriptions5' span={1}><div style={{ padding: '8px 4px' }}>亲子、婚恋、家庭等各类问题</div></Descriptions.Item>
                                    <Descriptions.Item className='descriptions6' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.personalLife}</div></Descriptions.Item>
                                  </Descriptions>
                                </Descriptions.Item>
                                <Descriptions.Item className='descriptions2' span={1}>
                                  <Descriptions bordered column={2}>
                                    <Descriptions.Item className='descriptions5' span={1}><div style={{ padding: '8px 4px' }}>学业&工作中的能力、适应、人际等问题</div></Descriptions.Item>
                                    <Descriptions.Item className='descriptions6' span={1}><div style={{ padding: '8px 4px', minHeight: 106, textAlign: 'center', lineHeight: '90px', color: 'red' }}>{info.socialFunction}</div></Descriptions.Item>
                                  </Descriptions>
                                </Descriptions.Item> */}
                              </Descriptions>
                            </Descriptions.Item>
                          </Descriptions>
                        </div>
                      </Descriptions.Item>
                      <Descriptions.Item span={3}>
                        <div>
                          <Descriptions bordered column={5}>
                            <Descriptions.Item className='descriptions20' span={1}>
                              <div style={{ padding: 8 }}>
                                {/* <TextArea value={info.biologicalConceptualization} style={{ height: 216 }} onChange={e => handleChange('biologicalConceptualization', e.target.value)} /> */}
                                {info.biologicalConceptualization}
                              </div>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={2}>
                              <div style={{ padding: 8 }}>
                                {/* <TextArea value={info.psychologicalConceptualization} style={{ height: 216 }} onChange={e => handleChange('psychologicalConceptualization', e.target.value)} /> */}
                                {info.psychologicalConceptualization}
                              </div>
                            </Descriptions.Item>
                            <Descriptions.Item className='descriptions40' span={2}>
                              <div style={{ padding: 8 }}>
                                {/* <TextArea value={info.socialConceptualization} style={{ height: 216 }} onChange={e => handleChange('socialConceptualization', e.target.value)} /> */}
                                {info.socialConceptualization}
                              </div>
                            </Descriptions.Item>
                          </Descriptions>
                        </div>
                      </Descriptions.Item>
                      {/* } */}
                      {
                        // 取消原来的概念化总结 220112
                        // info.socialConceptualization &&
                        //   <Descriptions.Item span={3}>
                        //     <div>
                        //       <Descriptions bordered column={1}>
                        //         <Descriptions.Item span={1}>
                        //           <div style={{ padding: '8px', minHeight: 34 }}>
                        //             <TextArea value={info.socialConceptualization} autoSize={{ minRows: 1 }} onChange={e => handleChange('socialConceptualization', e.target.value)}></TextArea>
                        //           </div>
                        //         </Descriptions.Item>
                        //       </Descriptions>
                        //     </div>
                        //   </Descriptions.Item>
                      }
                    </Descriptions>
                  </div>
                </Descriptions.Item>
              </Descriptions>
            </div>
          }


          {(info.physiologicalTreatmentCycle || info.psychologicalTreatmentCycle || info.societyTreatmentCycle || info.physiologicalTreatmentPrograms || info.psychologicalTreatmentPrograms || info.societyTreatmentPrograms || info.physiologicalTreatmentGoals || info.psychologicalTreatmentGoals || info.societyTreatmentGoals) &&
            <div className={styles.bspCommontContain}>
              <h3 className='title'><div>BPS-DPP循程服务路径</div></h3>
              <Descriptions bordered column={1}>
                <Descriptions.Item span={1} label="BPS维度">
                  <div className={styles.bspCommontContainChild5}>
                    <Descriptions bordered column={3}>
                      <Descriptions.Item className='descriptions1' span={1}>
                        <Descriptions bordered column={2}>
                          <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 52 }}>生物</div></Descriptions.Item>
                          <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px', minHeight: 52 }}>症状表现</div></Descriptions.Item>
                        </Descriptions>
                      </Descriptions.Item>
                      <Descriptions.Item className='descriptions1' span={1}>
                        <Descriptions bordered column={2}>
                          <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 52 }}>心理</div></Descriptions.Item>
                          <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px', minHeight: 52 }}>（易感因素）原生家庭人格</div></Descriptions.Item>
                        </Descriptions>
                      </Descriptions.Item>
                      <Descriptions.Item className='descriptions1' span={1}>
                        <Descriptions bordered column={2}>
                          <Descriptions.Item className='descriptions2' span={1}><div style={{ padding: '8px', minHeight: 52 }}>社会</div></Descriptions.Item>
                          <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px', minHeight: 52 }}>（诱发因素）个人生活社会功能</div></Descriptions.Item>
                        </Descriptions>
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                </Descriptions.Item>
                {(info.physiologicalTreatmentCycle || info.psychologicalTreatmentCycle || info.societyTreatmentCycle) &&
                  <Descriptions.Item span={1} label="DPP服务周期">
                    <div className={styles.bspCommontContainChild5}>
                      <Descriptions bordered column={3}>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>{info.physiologicalTreatmentCycle && DPP_TREATMENT_PATH_PHYSIOLOGICAL.filter(_ => _.value === info.physiologicalTreatmentCycle)[0].label}</div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>{info.psychologicalTreatmentCycle && DPP_TREATMENT_PATH_PHYSIOLOGICAL.filter(_ => _.value === info.psychologicalTreatmentCycle)[0].label}</div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 34, textAlign: 'center' }}>{info.societyTreatmentCycle && DPP_TREATMENT_PATH_PHYSIOLOGICAL.filter(_ => _.value === info.societyTreatmentCycle)[0].label}</div>
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
                {(info.physiologicalTreatmentPrograms || info.psychologicalTreatmentPrograms || info.societyTreatmentPrograms) &&
                  <Descriptions.Item span={1} label="DPP服务方式">
                    <div className={styles.bspCommontContainChild5}>
                      <Descriptions bordered column={3}>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 34 }}>{info.physiologicalTreatmentPrograms}</div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 34 }}>{info.psychologicalTreatmentPrograms}</div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 34 }}>{info.societyTreatmentPrograms}</div>
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
                {(info.physiologicalTreatmentGoals || info.psychologicalTreatmentGoals || info.societyTreatmentGoals) &&
                  <Descriptions.Item span={1} label="服务目标">
                    <div className={styles.bspCommontContainChild5}>
                      <Descriptions bordered column={3}>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 40 }}>
                            <TextArea value={info.physiologicalTreatmentGoals} style={{ height: 268 }} onChange={e => handleChange('physiologicalTreatmentGoals', e.target.value)} />
                          </div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 40 }}>
                            <TextArea value={info.psychologicalTreatmentGoals} style={{ height: 268 }} onChange={e => handleChange('psychologicalTreatmentGoals', e.target.value)} />
                          </div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions1' span={1}>
                          <div style={{ padding: '8px', minHeight: 40 }}>
                            <TextArea value={info.societyTreatmentGoals} style={{ height: 268 }} onChange={e => handleChange('societyTreatmentGoals', e.target.value)} />
                          </div>
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
              </Descriptions>
            </div>
          }
          {
            info.imageArray && info.imageArray.map(it => {
              return <img style={{ width: 750 }} src={it} />
            })
          }
        </div>
      </div>
    </Modal>

  );
};

export default Form.create()(PrintModal);
